import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { Me } from '../api/types';

interface SessionContextValue {
  me: Me;
  reloadMe: () => Promise<void>;
}

const SessionContext = createContext<SessionContextValue | null>(null);

export function SessionProvider({
  me,
  reloadMe,
  children,
}: SessionContextValue & { children: ReactNode }) {
  const value = useMemo<SessionContextValue>(() => ({ me, reloadMe }), [me, reloadMe]);
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used inside SessionProvider');
  }
  return context;
}
